import React from 'react';
import { connect } from 'react-redux';
import * as LX from '@utils/lxWrapper';
import pageJump from '@projects/Shell/utils/pageJump';

import { RootState } from '../../../../store';
import styles from './Notice.module.scss';

interface NoticeProps {
    /** 未读消息 */
    unReadNotificationCount: number;
}

const { useEffect } = React;
const Notice: React.FC<NoticeProps> = ({ unReadNotificationCount }) => {
    useEffect(() => {
        LX.reportMV('b_waimai_e_grfwokpp_mv', 'c_waimai_e_fa4ps4ng');
    }, []);

    return (
        <div className={styles.container}>
            <i
                className="iconfont icon-wmbwmb-xitongxiaoxi"
                onClick={() => {
                    LX.reportMC('b_waimai_e_grfwokpp_mc', 'c_waimai_e_fa4ps4ng');
                    pageJump.go('/v2/shop/msgbox/business');
                }}
            />
            {unReadNotificationCount ? <div className={styles.unreadTips} /> : ''}
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        unReadNotificationCount: state.shellHeader.unReadNotificationCount,
    };
};

export default connect(mapStateToProps)(Notice);
